import React from 'react';
import { SECURITY_ACTIONS, useSecurity } from '../../../common/auth/Security';
import ButtonWithIcon from '../../../common/components/ButtonWithIcon';
import { ENTITY_CONSTANTS } from '../../../common/constants/entityConstants';
import I18n from '../../../common/i18n/I18n';
import { Icons } from '../../../common/icons/Icons';

export interface ProductionStatusNoteAddButtonProps {
    onClick: () => void;
}

export default function ProductionStatusNoteAddButton({ onClick }: ProductionStatusNoteAddButtonProps) {
    /**
     * @todo: The explicit use of the `useSecurity()` hook here should be replaced by abstracting that check within the
     * `ButtonWithIcon` component itself, by allowing it to accept security actions and targets as props.
     * This would ensure that all such buttons across the application consistently enforce security checks without
     * requiring individual components to implement them separately.
     * In doing this we would effectively include the `ButtonWithIcon` within the catalog of
     * "security aware" interactive UI primitive components.
     */
    const { allowed: canEdit } = useSecurity(SECURITY_ACTIONS.EDIT, {
        entityName: ENTITY_CONSTANTS.production
    });

    if (!canEdit) {
        return null;
    }

    return (
        <ButtonWithIcon
            label={<I18n token="note.status" />}
            onClick={onClick}
            Icon={Icons.NoteAdd}
            fontSize="small"
            sx={{ width: 'fit-content', whiteSpace: 'nowrap' }}
            previewLabelInMobile={false}
        />
    );
}
